module.exports = __webpack_public_path__ + "static/voyage-white-overlay-mobile-9db98c8f4c94628459fd37f2d65e5b56.png";